import { api } from '../../api'
import type {
  FCMDevice,
  FCMTestResponse,
  RegisterFCMDevicePayload,
} from '../../../types/notification.types'

export type {
  FCMDevice,
  FCMDevicePlatform,
  FCMTestResponse,
  RegisterFCMDevicePayload,
} from '../../../types/notification.types'

export const registerFCMDevice = async (payload: RegisterFCMDevicePayload): Promise<FCMDevice> => {
  const res = await api.post<FCMDevice>('notifications/devices/', payload)
  return res.data
}

export const unregisterFCMDevice = async (token: string): Promise<void> => {
  await api.delete(`notifications/devices/${encodeURIComponent(token)}/`)
}

export const sendTestFCM = async (): Promise<FCMTestResponse> => {
  const res = await api.post<FCMTestResponse>('notifications/devices/test/')
  return res.data
}
